<div class="w-full h-full p-1">
  <p-dialog [draggable]="false" [visible]="isDialogVisible" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i> <label>{{ disabledMessage }}</label>
    <br />
    <br />
  </p-dialog>

    <app-tool-loader class="drillstring" [isLoading]="isLoading()" [positionUnset]="true">
    <p-scrollPanel [style]="{ width: '100%', height: '92%' }">
      <form [formGroup]="drillstringForm">

        <div class="flex flex-col mt-2 space-y-2">

          <p-fieldset legend="Drill Pipe">
            <div class="flex items-end gap-2">
              <!-- Select Box -->
              <div class="flex-1">
                <label class="mb-2">Drill Pipe</label>
                <app-units-select-input formControlName="drillPipe" dataKey="id" [options]="drillPipes"
                  [optionLabelFormatter]="formatPipeLabel"
                  [placeholder]="getPipePlaceholder(drillstringForm.get('drillPipe')?.value, drillPipes)"
                  appendTo="body" class="w-full" ariaLabel="Drill Pipe"></app-units-select-input>
              </div>
              <div class="flex-1 max-w-xs">
                <label class="mb-2">Grade</label>
                <div class="flex flex-1 items-center gap-2">
                  <p-select filter filterBy="name" resetFilterOnHide="true" formControlName="drillPipeGrade" dataKey="id" [options]="drillPipeGrades" appendTo="body"
                    class="w-full" [placeholder]="getGradePlaceholderText(drillstringForm.get('drillPipeGrade')?.value)">
                    <ng-template pTemplate="selectedItem">
                      {{ getGradePlaceholderText(drillstringForm.get('drillPipeGrade')?.value) }}
                    </ng-template>
                    <ng-template let-grade pTemplate="item">
                      {{ grade.name }}
                    </ng-template>
                  </p-select>
                    @if (drillstringId && drillstringForm.get('drillPipeGrade')?.value) {
                      <ng-container>
                        <app-catalog-item-preview
                          [item]="drillstringForm.get('drillPipeGrade')?.value"
                          buttonTooltip="Grade Details"
                        ></app-catalog-item-preview>
                      </ng-container>
                    }
                  </div>
                </div>
              <!-- Button -->
              <p-button class="outlined-button" outlined="true" size="small" severity="danger" pTooltip="Reset Drill Pipe" label="Reset"
                (onClick)="resetDrillPipe()"></p-button>
            </div>
          </p-fieldset>

          <p-fieldset [class.opacity-50]="isTubingOrTieback" [class.pointer-events-none]="isTubingOrTieback" legend="Heavy Weight Drill Pipe">
            <div class="flex items-end gap-2">

              <div class="flex-1">
                <label class="mb-2">HWDP</label>
                <app-units-select-input formControlName="heavyWeightDrillPipe" dataKey="id" [options]="hwdps"
                  [optionLabelFormatter]="formatPipeLabel"
                  [placeholder]="getPipePlaceholder(drillstringForm.get('heavyWeightDrillPipe')?.value, hwdps)"
                  appendTo="body" class="w-full" ariaLabel="HWDP"></app-units-select-input>
              </div>

              <div class="flex-1 max-w-xs">
                <label class="mb-2">Grade</label>
                <div class="flex flex-1 items-center gap-2">
                  <p-select filter filterBy="name" resetFilterOnHide="true" formControlName="hwdpGrade" dataKey="id" [options]="hwdpGrades" appendTo="body"
                    class="w-full" [placeholder]="getGradePlaceholderText(drillstringForm.get('hwdpGrade')?.value)">
                    <ng-template pTemplate="selectedItem">
                      {{ getGradePlaceholderText(drillstringForm.get('hwdpGrade')?.value) }}
                    </ng-template>
                    <ng-template let-grade pTemplate="item">
                      {{ grade.name }}
                    </ng-template>
                  </p-select>
                  @if (drillstringId && drillstringForm.get('hwdpGrade')?.value) {
                    <app-catalog-item-preview
                      [item]="drillstringForm.get('hwdpGrade')?.value"
                      buttonTooltip="Grade Details"
                    ></app-catalog-item-preview>
                  }
                </div>
              </div>

              <div class="flex-1 max-w-xs">
                <label class="mb-2">Length</label>
                <app-validated-number-input
                  [id]="'hwdpLength'"
                  [control]="control('hwdpLength')"
                  [value]="control('hwdpLength').value"
                  [validation]="hwdpLengthValidation"
                  [unit]="longLengthUnit"
                ></app-validated-number-input>
              </div>
              <p-button class="outlined-button" size="small" severity="danger" outlined="true" pTooltip="Reset HWDP Data"
                label="Reset" (onClick)="resetHwdp()">
              </p-button>
            </div>
          </p-fieldset>

          <p-fieldset [class.opacity-50]="isTubingOrTieback" [class.pointer-events-none]="isTubingOrTieback" legend="Collars">
            <div class="flex items-end gap-2">

              <div class="flex-1">
                <label class="mb-2">Collar</label>
                <app-units-select-input formControlName="collar" dataKey="id" [options]="collars"
                  [optionLabelFormatter]="formatPipeLabel"
                  [placeholder]="getPipePlaceholder(drillstringForm.get('collar')?.value, collars)"
                  appendTo="body" class="w-full" ariaLabel="Collar"></app-units-select-input>
              </div>

              <div class="flex-1 max-w-xs">
                <label class="mb-2">Grade</label>
                <div class="flex flex-1 items-center gap-2">
                  <p-select filter filterBy="name" resetFilterOnHide="true" formControlName="collarGrade" dataKey="id" [options]="collarGrades" appendTo="body"
                    class="w-full" [placeholder]="getGradePlaceholderText(drillstringForm.get('collarGrade')?.value)">
                    <ng-template pTemplate="selectedItem">
                      {{ getGradePlaceholderText(drillstringForm.get('collarGrade')?.value) }}
                    </ng-template>
                    <ng-template let-grade pTemplate="item">
                      {{ grade.name }}
                    </ng-template>
                  </p-select>
                  @if (drillstringId && drillstringForm.get('collarGrade')?.value) {
                    <app-catalog-item-preview
                      [item]="drillstringForm.get('collarGrade')?.value"
                      buttonTooltip="Grade Details"
                    ></app-catalog-item-preview>
                  }
                </div>
              </div>
          
              <div class="flex-1 max-w-xs">
                <label class="mb-2">Length</label>
                <app-validated-number-input
                  [id]="'collarLength'"
                  [control]="control('collarLength')"
                  [value]="control('collarLength').value"
                  [validation]="collarLengthValidation"
                  [unit]="longLengthUnit"
                ></app-validated-number-input>
              </div>
          
              <p-button
                class="outlined-button"
                size="small"
                severity="danger"
                outlined="true"
                pTooltip="Reset Collar Data"
                label="Reset"
                (onClick)="resetCollar()"
              ></p-button>
            </div>

          </p-fieldset>

        </div>
      </form>

    </p-scrollPanel>
  </app-tool-loader>
</div>
